<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">
        These are suggestions and are not saved. A job number in the PO, or at the start of the job text, is used first. Otherwise the job text is
        compared with the Viewpoint job name. Vista job numbers keep the trailing period they are stored with.
    </p>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="jobGrid"></action-toolbar-count>
                <grid-export [grid]="gridPurchasedJobs" [name]="'Purchased Material Jobs'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="jobGrid"></grid-column-group>
    <wj-flex-grid
        id="gridPurchasedJobs"
        #gridPurchasedJobs
        style="height: 320px"
        [isReadOnly]="true"
        (initialized)="jobGrid.initialize(gridPurchasedJobs)"
        (destroy)="jobGrid.destroy()"
        [itemsSource]="jobGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Vista job'" [binding]="'job'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Job name'" [binding]="'jobName'" [width]="320" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Invoices'" [binding]="'invoiceCount'" [width]="100" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Top categories'" [binding]="'topCategories'" [width]="220" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Reason'" [binding]="'reason'" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridPurchasedJobs"></grid-selection-calculation>

    <h5 class="mt-3">Unmatched job and PO text</h5>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="unmatchedGrid"></action-toolbar-count>
                <grid-export [grid]="gridUnmatchedJobs" [name]="'Purchased Material Unmatched Jobs'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="unmatchedGrid"></grid-column-group>
    <wj-flex-grid
        id="gridUnmatchedJobs"
        #gridUnmatchedJobs
        style="height: 240px"
        [isReadOnly]="true"
        (initialized)="unmatchedGrid.initialize(gridUnmatchedJobs)"
        (destroy)="unmatchedGrid.destroy()"
        [itemsSource]="unmatchedGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Job or PO text'" [binding]="'text'" [width]="420" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Invoices'" [binding]="'invoiceCount'" [width]="100" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridUnmatchedJobs"></grid-selection-calculation>
</div>
